

// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
 import { StringLiteralLike } from "typescript";
import {Deserializable} from "./deserializable.model";

export class VariableCodeBlock {

        public variable_code_block_id?: number;
        public variable_code_block_name?: string;
        public variable_code_block_notes?: any;
        public variable_code_block_description?: string;
        public variable_code_block_type_id?: number; // This will eventually determin where and create rules on when used and displayed.
        public variable_code_block_insert_type_id?: number; // This will eventually determin where and create rules on when used and displayed.

        public variable_code_block_as_actual?: any;
        public variable_code_block_as_actual_NAME?: any;
        public variable_code_block_as_variable?: any;
        public variable_code_block_as_variable_NAME?: string;


        public variable_code_block_HTML_FILE?: any;

        public variable_code_block_1?: any;
        public variable_code_block_2?: any;
        public variable_code_block_3?: any;
        public variable_code_block_4?: any;
        public variable_code_block_5?: any;

        
                // Not yet used or created in data or structure.
                    public subject_com_type_id?: number;
                    public brand_type_id?: number;

                    public is_active?: any;
                    // if is of type affidavit court documents.
                    // new logic to handle all document and correspondece creation in system
                    public job_type_affidavit_type_id?: any;
                    public job_type_court_id?: any;
                    public job_type_location_id?: any;
                    public job_type_id?: any;
                    public job_type_document_type_id?: any;

                    public brand_id?: number;
                    public user_id?: number;
                    public user_level_id?: number;
                    public keywords?: any;
                    public routerLink?: string;

                    public variable_code_block_database_table?: string;
                    public variable_code_block_database?: string;
                    public variable_code_block_database_model?: string;
                    public variable_code_block_database_server?: string;


                    // seach system    
                    created_date_from?;
                    created_date_to?;


                    public log_type_data_sector_id?: number;
                    public log_type_data_sector_name?: any;
}

  // Set the Stats
